import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { FileText, PlayCircle, Share2, BarChart3, RefreshCw, Wand2 } from 'lucide-react';
interface SlideWhatSnakkerDoesProps {
  onContinue: () => void;
}
export function SlideWhatSnakkerDoes({
  onContinue
}: SlideWhatSnakkerDoesProps) {
  const [stage, setStage] = useState(0);
  const steps = [{
    id: 'ingest',
    icon: <FileText className="w-6 h-6 text-teal-400" data-id="element-1161" data-mp="2vxecp9cyaq84" />,
    title: 'Ingest',
    desc: 'Takes existing approved content'
  }, {
    id: 'transform',
    icon: <Wand2 className="w-6 h-6 text-purple-400" data-id="element-1162" data-mp="35wvg1k4qcs0x" />,
    title: 'Transform',
    desc: 'Turns them into short interactive Snaks'
  }, {
    id: 'publish',
    icon: <Share2 className="w-6 h-6 text-sky-400" data-id="element-1163" data-mp="1bi2mdqneqbbm" />,
    title: 'Publish',
    desc: 'Distributes across all channels'
  }, {
    id: 'learn',
    icon: <BarChart3 className="w-6 h-6 text-rose-400" data-id="element-1164" data-mp="1gh5qn8vkcdij" />,
    title: 'Learn',
    desc: 'Captures behavioral data'
  }, {
    id: 'improve',
    icon: <RefreshCw className="w-6 h-6 text-amber-400" data-id="element-1165" data-mp="33icqvfuw8f0f" />,
    title: 'Improve',
    desc: 'Optimizes the next campaign'
  }];
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 400);
    const t2 = setTimeout(() => setStage(2), 1000);
    const timers = steps.map((_, idx) => setTimeout(() => setStage(3 + idx), 1500 + idx * 350));
    const finalTimer = setTimeout(() => setStage(3 + steps.length), 1500 + steps.length * 350 + 300);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      timers.forEach(clearTimeout);
      clearTimeout(finalTimer);
    };
  }, []);
  return <div className="h-full w-full flex flex-col px-8 py-10 md:px-20 md:py-14 max-w-6xl mx-auto" data-id="element-1166" data-mp="3d862uhyy6w57">
      {/* Heading */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center space-y-4" data-id="element-1167" data-mp="25sj715tsz85f">
        <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-1168" data-mp="238le0khr4cxf">
          What a campaign looks like
        </h2>
        <p className="text-xl text-white/60" data-id="element-1169" data-mp="1tcidtk6gmod4">
          The operating layer between strategy and execution.
        </p>
      </motion.div>

      {/* Flow diagram */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: stage >= 2 ? 1 : 0,
      y: stage >= 2 ? 0 : 20
    }} transition={{
      duration: 0.6
    }} className="flex-1 flex items-center justify-center mt-10" data-id="element-1170" data-mp="1ydfvlvnk5ge3">
        <div className="w-full rounded-2xl bg-white border border-white/10 shadow-2xl overflow-hidden" data-id="element-1171" data-mp="1fkva4za6udkb">
          <img src="https://cdn.magicpatterns.com/uploads/aDhBbAFowWKRHKXg1acHd3/Screenshot_2026-05-28_at_11.46.20.png" alt="Flow Example Campaign — Hook to Snak to Insights" className="w-full h-auto block" data-id="element-1172" data-mp="11lcdb2mtuonb" />
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 6 ? 1 : 0
    }} className="mt-16 flex justify-center" data-id="element-1173" data-mp="hzagtn7zpo0m"></motion.div>
    </div>;
}